import { Component, OnInit } from '@angular/core';
import { SettlementServiceService } from '../../../services/raintree/Transmission/settlement-service.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { MandirBillFilterComponent } from '../mandir-bill-filter/mandir-bill-filter.component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { WorkerViewComponent } from './worker-view/worker-view.component';
import { LoaderComponent } from '../../../common-component/loader/loader.component';
import { BillDetailsComponent } from './bill-details/bill-details.component';
import { log } from 'node:console';
import { ViewAdvanceDetailsComponent } from './view-advance-details/view-advance-details.component';

@Component({
  selector: 'app-mandir-bill',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './mandir-bill.component.html',
  styleUrl: './mandir-bill.component.scss',
})
export class MandirBillComponent implements OnInit {
  unSettledMandir: mandirDetails[] = [];
  pageNo: number = 1;
  searchCode = new FormControl('')
  workerData: any[] = [];
  resFilter: any;


  constructor(
    private settledService: SettlementServiceService,
    private toastr: ToastrService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.getMandirDetails({ pageno: this.pageNo });
    // this.unSettledMandir = dummyData;
  }

  onClickFilter() {
    const dialogRef = this.dialog.open(MandirBillFilterComponent, {
      width: '620px',
      panelClass: 'custom-dialog-container',
      data: this.resFilter,
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res) {
          this.getMandirDetails({
            pageno: this.pageNo,
            fy: res?.financeYear,
            uiState: res?.state,
            uiDistrict: res?.district
          })
          this.resFilter = {
            fy: res.financeYear,
            state: res.state,
            district: res.district,
            isAllDistrict: res.isAllDistrict
          }
        }
        // else {
        //   this.getMandirDetails({pageno: this.pageNo});
        // }
      }
    })
  }

  getMandirDetails(queryParams: any) {
    this.settledService.getUnsettledMandir(queryParams).subscribe({
      next: (res) => {
        console.log(res);

        this.unSettledMandir = res.data;
        console.log('Data mil gaya', this.unSettledMandir);
      },
      error: (err) => {
        console.log(err.message);
      },
    });
  }

  getMandirByCode() {
    this.getMandirDetails({
      pageno: this.pageNo,
      mandircode: this.searchCode.value
    })
  }

  viewWorker(code: any) {
    // getWorkerDetails(queryParams:string) {
    this.settledService.getWorkerDetails({ mandircode: code }).subscribe({
      next: (res) => {
        this.workerData = res.data.workers;
        console.log(this.workerData)
        if (this.workerData.length > 0) {
          const dialogRef = this.dialog.open(WorkerViewComponent, {
            width: '620px',
            panelClass: 'custom-dialog-container',
            data: this.workerData,
          });
        } else {
          this.toastr.error('No worker records found')
        }
      },
      error: (err) => {
        console.log(err.message);

      }
    })
  }
  // console.log(row,'seleted row data');
  // const dialogRef = this.dialog.open(WorkerViewComponent, {
  //   width: '620px',
  //   panelClass: 'custom-dialog-container',
  //   data: row,
  // });

  formatIndianCurrency(amount: string | number): string {
    const number = Number(amount);
    if (isNaN(number)) return '--';

    return (
      '₹ ' +
      number.toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  }

  openBillDetails(data: any) {
    const mandirCode = data.scoa_code;
    let fy = this.resFilter?.fy ? this.resFilter?.fy : '';
    // const fy = this.dateToFY(data.last_advance_date)
    // console.log("financial year:", fy, 'for the date', data.last_advance_date);
    const dialogRef = this.dialog.open(BillDetailsComponent, {
      width: '70vw',
      panelClass: 'custom-dialog-container',
      data: { mandirCode, fy },
    });
    dialogRef.afterClosed().subscribe({
      next: (res) => { }
    })
  }

  openAdvanceDetails(data: any) {
    const mandirCode = data.scoa_code;
    // const fy = this.dateToFY(data.last_advance_date)
    let fy = this.resFilter?.fy ? this.resFilter?.fy : '';
    console.log(fy, "filtered fy")
    // console.log("financial year:", fy, 'for the date', data.last_advance_date);
    const dialogRef = this.dialog.open(ViewAdvanceDetailsComponent, {
      width: '70vw',
      panelClass: 'custom-dialog-container',
      data: { mandirCode, fy },
    });
    dialogRef.afterClosed().subscribe({
      next: (res) => { }
    })
  }

  isValidAmount(value: any): boolean {
    return value !== null && value !== undefined && !isNaN(value) && Number(value) !== 0;
  }


  dateToFY(dateValue: any) {
    const date = new Date(dateValue);
    const year = date.getFullYear();
    const month = date.getMonth();
    let fy: number;
    if (month > 3) {
      fy = year;
    } else {
      fy = year - 1;
    }
    return fy.toString()
  }

}



interface mandirDetails {
  scoa_name: string;
  scoa_code: string;
  state_name: string;
  district_name: string;
  total_advance_given: string;
  total_bill_payment: string;
  remaining_amount: string;
  last_advance_date: string;
  last_bill_receive_date: null;
}

const dummyData = [
  {
    scoa_name: '68, SURYA SEN STREET MANDIR',
    scoa_code: 'SURSN',
    state_name: 'WEST BENGAL',
    district_name: 'KOLKATA',
    total_advance_given: '510000.00',
    total_bill_payment: '0',
    remaining_amount: '510000.00',
    last_advance_date: '2025-07-29',
    last_bill_receive_date: null,
  },

  {
    scoa_name: 'SATSANG VIHAR PURUSHOTTOMPUR',
    scoa_code: 'SVPP',
    state_name: 'WEST BENGAL',
    district_name: 'PURBA MEDINIPUR',
    total_advance_given: '610000.00',
    total_bill_payment: '0',
    remaining_amount: '610000.00',
    last_advance_date: '2025-05-29',
    last_bill_receive_date: null,
  },

  {
    scoa_name: 'SATSANG VIHAR BANGALORE',
    scoa_code: 'SVBNG',
    state_name: 'KARNATAKA',
    district_name: 'BANGALORE',
    total_advance_given: '750000.00',
    total_bill_payment: '0',
    remaining_amount: '750000.00',
    last_advance_date: '2025-07-20',
    last_bill_receive_date: null,
  },

  {
    scoa_name: 'SATSANG VI8HAR CHENNAI',
    scoa_code: 'SVC',
    state_name: 'TAMILNARU',
    district_name: 'CHENNAI',
    total_advance_given: '510000.00',
    total_bill_payment: '0',
    remaining_amount: '510000.00',
    last_advance_date: '2025-07-29',
    last_bill_receive_date: null,
  },

  {
    scoa_name: 'TEST',
    scoa_code: 'TSVG',
    state_name: 'WEST BENGAL',
    district_name: 'UTTAR 24 PARGANA',
    total_advance_given: '510000.00',
    total_bill_payment: '0',
    remaining_amount: '710000.00',
    last_advance_date: '2025-07-29',
    last_bill_receive_date: null,
  },

  {
    scoa_name: 'BELGHORIA SATSANG VIHAR',
    scoa_code: 'BSV',
    state_name: 'WEST BENGAL',
    district_name: 'KOLKATA',
    total_advance_given: '310000.00',
    total_bill_payment: '0',
    remaining_amount: '510000.00',
    last_advance_date: '2025-02-29',
    last_bill_receive_date: null,
  },
];
